<script setup lang="ts">
import { onMounted, shallowRef } from "vue";
import { AgGridVue } from "ag-grid-vue3";
import {
  themeQuartz,
  type GridApi,
  type GridOptions,
  type GridReadyEvent,
} from "ag-grid-enterprise";
import {useAcmiStore} from "@/charter/stores/charter-acmi-store.ts";

const acmiStore = useAcmiStore();

const myTheme = themeQuartz.withParams({});

const gridOptions: GridOptions = {
  pagination: true,
  autoSizeStrategy: {
    type: "fitGridWidth",
    defaultMinWidth: 100,
  },
  defaultColDef: {
    resizable: false,
    filter: true,
  },
  columnDefs: [
    { field: "aircraftTypeId", headerName: "Aircraft" },
    { field: "acins", headerName: "AC & Ins" },
    { field: "mxvar", headerName: "MX-VAR" },
    { field: "mxfix", headerName: "MX-Fix" },
    { field: "cockpitCrew", headerName: "Cockpit crew" },
    { field: "cabinCrew", headerName: "Cabin crew" },
    { field: "ttlacmi", headerName: "TTL ACMI" },
    { field: "fixedCost", headerName: "Fixed cost / bh" },
    { field: "totalCrewCost", headerName: "Total crew cost" },
  ],
};

const gridApi = shallowRef<GridApi | null>(null);

onMounted(async () => {
  await acmiStore.fetchAcmi();
});

function onGridReady(params: GridReadyEvent) {
  gridApi.value = params.api;
}

async function refreshData() {
  await acmiStore.fetchAcmi();
}
</script>

<template>
  <div class="flex h-full flex-col gap-4">
    <div class="flex items-center justify-between">
      <h2>ACMI Data</h2>
      <div class="flex gap-2">
        <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" outlined @click="refreshData" />
      </div>
    </div>

    <AgGridVue
      :rowData="acmiStore.acmiList"
      :loading="acmiStore.isLoading"
      :gridOptions="gridOptions"
      :theme="myTheme"
      class="ag-grid-container"
      @grid-ready="onGridReady"
    />
  </div>
</template>

<style scoped lang="scss">
.ag-grid-container {
  width: 100%;
  height: 400px;
}

h2 {
  margin: 0 !important;
}

.p-button {
  min-height: fit-content !important;
}

.p-button-icon-left {
  margin-right: 0.4375rem !important;
}

.p-button-label {
  font-weight: 700 !important;
}

.p-button-outlined {
  background-color: white !important;
  color: rgb(30, 41, 59) !important;
  font-size: 14px;
  line-height: 21px !important;
  padding: 6px 10px;
  border-radius: 6px;
  border-color: #e2e8f0 !important;
}

.p-button-outlined:hover {
  background-color: var(--p-button-outlined-secondary-hover-background) !important;
}

.p-button-outlined:active {
  background-color: var(--p-button-outlined-secondary-active-background) !important;
}
</style>
